import gql from 'graphql-tag'

export const LISTING_DISCOUNT = gql`
    fragment FragmentGlobalDiscount on Listing {
        globalDiscount {
            id
            percentage
            customerGroupType
            campaign
            orderchampContributionPercentage
        }
        loyaltyDiscount {
            campaign
            percentage
            orderchampContributionPercentage
        }
        bulkDiscounts {
            ends_at
            percentage
            customerGroupType
            percentage
            databaseId
            minimumQuantity
            orderchampContributionPercentage
        }
    }
`

export const LISTING_VARIANT = gql`
    fragment FragmentListingVariant on ListingVariant {
        id
        image {
            id
            transformedUrl(width: 260, height: 260)
            x1: transformedUrl(width: 480, height: 480)
        }
        inventory
        inventoryPolicy
        options {
            value
            name
        }
    }
`

export const LISTING = gql`
    ${LISTING_DISCOUNT}
    fragment FragmentListing on Listing {
        ...FragmentGlobalDiscount
        caseQuantity
        minimumOrderQuantity
        databaseId
        id
        image {
            id
            transformedUrl(width: 100, height: 100, method: FILL)
            x1: transformedUrl(width: 480, height: 480)
        }
        isFavorite
        priceMin
        title
        description
        translation {
            description
        }
        variantsCount
    }
`

export const LISTING_EDGES = gql`
    ${LISTING_DISCOUNT}
    fragment FragmentListingEdges on ListingConnection {
        edges {
            node {
                ...FragmentGlobalDiscount
                availableAt
                brand
                databaseId
                id
                images(first: 1) {
                    totalCount
                    edges {
                        node {
                            id
                            x1: transformedUrl(width: 480, height: 480)
                            x2: transformedUrl(width: 800, height: 800)
                            transformedUrl(
                                width: 1200
                                height: 1200
                                method: FILL
                            )
                        }
                    }
                }
                inStock
                isFavorite
                msrpMin
                priceMin
                storefront {
                    id
                    slug
                    minimumOrderAmount
                    retailerApprovalStatus
                    isStarSeller
                    needsRetailerApproval
                    campaignDiscount {
                        id
                        campaign
                        percentage
                        createdAt
                        orderchampContributionPercentage
                    }
                }
                title
                description
                translation {
                    description
                }
                url
            }
        }
    }
`
